import { createFeature, createSelector } from '@ngrx/store';
import { donationsFeedAdapter, donationsFeedReducer } from './reducer';
import { toCardVM } from '../../types/donations-feed/models';

export const donationsFeedFeature = createFeature({
  name: 'donationsFeed',
  reducer: donationsFeedReducer,
});

const { selectEntities, selectAll } = donationsFeedAdapter.getSelectors();

export const selectFeedState = donationsFeedFeature.selectDonationsFeedState;
export const selectLoading = createSelector(selectFeedState, (s) => s.loading);
export const selectError = createSelector(selectFeedState, (s) => s.error);
export const selectAllDonations = createSelector(selectFeedState, selectAll);
export const selectUniqueDonorsCount = createSelector(
  selectAllDonations,
  (list) => new Set(list.map((donation) => donation.donorKey)).size
);
export const selectCardVMs = createSelector(selectAllDonations, (list) =>
  list.map(toCardVM)
);
export const selectMyLikes = createSelector(selectFeedState, (s) => s.myLikes);
export const selectEntitiesMap = createSelector(
  selectFeedState,
  selectEntities
);
